<template>
  <div>
    <el-tabs
      v-model="activeName"
      type="card"
    >
      <el-tab-pane
        label="当日订货汇总"
        name="orderInquiry"
      >
        <orderInquiry />
      </el-tab-pane>
      <el-tab-pane
        label="当日订货明细"
        name="orderDetailInquiry"
      >
        <orderDetailInquiry />
      </el-tab-pane>
      <el-tab-pane
        label="历史订货汇总"
        name="historicalOrderInquiry"
      >
        <historicalOrderInquiry />
      </el-tab-pane>
      <el-tab-pane
        label="历史订货明细"
        name="historicalOrderDetailInquiry"
      >
        <historicalOrderDetailInquiry />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import orderInquiry from './order-inquiry'
import orderDetailInquiry from './order-detail-inquiry'
import historicalOrderInquiry from './historical-order-inquiry'
import historicalOrderDetailInquiry from './historical-order-detail-inquiry'
export default {
  name: 'Index',
  components: {
    orderInquiry,
    orderDetailInquiry,
    historicalOrderInquiry,
    historicalOrderDetailInquiry
  },
  data () {
    return {
      activeName: 'orderInquiry',
    }
  }
}

</script>
